export default __webpack_public_path__ + "static/media/Use-Cases-Section-Open-Project.d97b8e77.jpg";